'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/tabs/style/css.js
// module id = 502
// module chunks = 213534597649335